//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import { computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

export default {
  name: 'OrganizerList',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    titleIcon: {
      type: String,
      default: '',
    },
    showAction: {
      type: Boolean,
      default: false,
    },
    actionText: {
      type: String,
      default: '',
    },
    organizers: {
      type: Array,
      default: () => [],
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const computedTitle = computed(() => props.title)

    return {
      // computed
      computedTitle,

      avatarText,
    }
  },
}
